import React, { Fragment, useRef } from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import { useNavigate, useLocation } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Cookies from "universal-cookie";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { getRequisitionUUID, departmentKeyValue1, addIssuance, getWarehouseKeyValueList } from "../../../services/index";
import { getStoreTransferAvailableBatches } from "../../../services/Inventory/StoreTransferService";
import AddIcon from "@mui/icons-material/Add";
import { Spinner } from "react-bootstrap";
import Button from "@mui/material/Button";
import { GET_ALL_ITEMS_FOR_ISSUANCE, acceptRejectRequisition, getPendingRequisition } from "../../../services/Production/RequisitionServices";
import { sortLatestFirst } from "../../utils/textUtils";
import { getFormattedNumber } from "../../utils/textUtils";

const IssuanceNew = () => {
    const navigate = useNavigate();
    const location = useLocation();
    let reqId = location?.state?.reqId;
    let loginData1 = new Cookies().get("loginData1");
    var curr = new Date();
    curr.setDate(curr.getDate());
    var date1 = curr.toISOString().substring(0, 10);
    const tempRow = {
        item: "",
        itemId: "",
        stock: 0,
        issuanceUnit: "",
        qty: 0,
        requestedQuantity: 0,
        requestedUnitTitle: "",
        openRequestedQuantity: 0,
        inhandQuantity: 0,
        inHandUnit: "",
        issuedUnit: "",
        requestedUnitId: "",
        inHandQuantity: 0,
        inHandQuantityUnitTitleUuid: "",
        inHandQuantityUnitTitle: "",
        issuedQuantity: 0,
        issuedQuantityUnitId: "",
        issuedQuantityUnitTitle: "",
        openIssuedQuantity: 0,
        unitConversion: "",
        unitConversionTitle: "",
        currentStockBoxQuantity: "",
        currentStockOpenQuantity: "",
        updatedInHandQty: "",
        beanBillBatch: [],
        beanBatchList: [],

    };

    const [issInfo, setIssInfo] = useState({
        ware: { value: "", label: "Select Warehouse" },
        user: { value: loginData1?.recordId, label: loginData1?.fullName },
        dept: { value: "", label: "Select department" },
        date: date1,
        note: "",
        noteByIssue: "",
    });
    const [warehouseIdIss, setWarehouseIdIss] = useState("");
    const [rows, setRows] = useState([tempRow]);
    const [itemOptions, setItemOptions] = useState("");
    const [itemOptions2, setItemOptions2] = useState("");
    const [wareOptions, setWareOptions] = useState("");
    const [deptOptions, setDeptOptions] = useState("");
    const [requisitionDetails, setRequisitionDetails] = useState(null);
    const [onPage, setOnPage] = useState("issuance");
    const [loading, setLoading] = useState(false);
    const [requisitionList, setRequisitionList] = useState([]);
    const [filteredRequisitionList, setFilteredRequisitionList] = useState([]);
    const [itemLoading, setItemLoading] = useState(false);


    useEffect(() => {
        if (location.pathname === "/issueitems/new" && reqId) {
            setOnPage("issuanceFromRequisition");
        } else {
            setOnPage("issuance");
        }
    }, []);

    useEffect(() => {
        if (onPage === "issuanceFromRequisition") {
            tempRow.units = [
                {
                    label: "",
                    value: "",
                },
            ];
            tempRow.selectedUnit = {
                label: "",
                value: "",
            };
            tempRow.requestedQuantity = 0;
        }
    }, [onPage]);

    useEffect(() => {
        if (reqId) {
            getRequisitionUUID(reqId).then((response) => {
                if (response.errorCode === 0) {
                    let res = response.responsePacket;
                    setIssInfo({
                        ware: { label: res.warehouseTitle, value: res.warehouseId },
                        user: {
                            value: res.requestingUserId,
                            label: res.requestingUserTitle,
                        },
                        dept: {
                            label: res.requestingDepartmentTitle,
                            value: res.requestingDepartmentId,
                        },
                        date: res.requestDate,
                        note: "",
                        reqCode: res.requisitionCode,
                        requisitionId: res.recordId,
                    });
                    getRequisitionItems(res.warehouseId, res.requestingDepartmentId);
                    setRequisitionDetails(res);
                    setWarehouseIdIss(res.warehouseId);
                } else {
                    toast(response.message);
                }
            });
        }
    }, []);

    useEffect(() => {
        getWarehouseKeyValueList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setWareOptions(options);
            } else {
                toast(res.message);
            }
        });

        departmentKeyValue1().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setDeptOptions(options);
            } else {
                toast(res.message);
            }
        });
    }, []);

    const handleWare = (e) => {
        setRows([tempRow]);
        setIssInfo({ ...issInfo, ware: e, dept: { value: "", label: "Select department" } });
    };

    const handleDepartmentSelect = (e) => {
        setIssInfo({ ...issInfo, dept: e });
        setRows([tempRow]);
        getRequisitionItems(issInfo.ware.value, e.value);
    }

    const getRequisitionItems = (warehouseId, departmentId) => {
        let data = {
            page: 0,
            search: "",
            size: -1,
            uuid: warehouseId,
            uuid2: departmentId
        };
        setItemLoading(true);
        GET_ALL_ITEMS_FOR_ISSUANCE(data).then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket.data?.map((d) => ({
                    value: d.itemTitle,
                    itemId: d.itemId,
                    itemTitle: d.itemTitle,
                    label: (
                        <div className="selectItemOptions">
                            <div className="font-size-14 font-weight-bold">{d.itemTitle}</div>
                            <div className={`row font-size-13 ${d.currentStockBoxQuantity <= 0 && d.currentStockOpenQuantity <= 0 ? "text-danger" : ""}`}>
                                <div className="col-6">Available Stock:</div>
                                <div className="col-3">
                                    <span>
                                        {d.currentStockBoxQuantity?.toFixed(2)} ({d.packUnitTitle})
                                    </span>
                                </div>
                                <div className="col-3">
                                    <span>
                                        {d.currentStockOpenQuantity?.toFixed(2)} ({d.unitName})
                                    </span>
                                </div>
                            </div>
                            <span className="font-size-13">Rate: {d.sellingPriceValue}</span>
                        </div>
                    ),
                    warehouseId: d.warehouseId,
                    warehouseTitle: d.warehouseTitle,
                    unitId: d.unitId,
                    unitName: d.unitName,
                    unitConversionTitle: d.unitConversionTitle,
                    unitConversion: d.unitConversion,
                    currentStockOpenQuantity: d.currentStockOpenQuantity,
                    currentStockBoxQuantity: d.currentStockBoxQuantity,
                    units: [
                        { value: d.unitId, label: d.unitName, stock: d.currentStockOpenQuantity },
                        { value: d.packUnitId, label: d.packUnitTitle, stock: d.currentStockBoxQuantity },
                    ],
                    selectedUnit: { value: d.unitId, label: d.unitName, stock: d.currentStockOpenQuantity },
                    inHandQuantity: d.inHandQuantity,
                    inHandQuantityUnitTitle: d.inHandQuantityUnitTitle,
                    beanBatchList: [],
                }));
                setItemOptions(options);
                setItemOptions2(options);
                setItemLoading(false);
            } else {
                toast(res.message);
            }
        });
    };


    useEffect(() => {
        if (requisitionDetails && requisitionDetails.requestedItemsBeanList && issInfo.ware.value !== "" && itemOptions && rows[0].item === "") {
            getSelectedItems(itemOptions);
        }
    }, [requisitionDetails, itemOptions]);


    const getSelectedItems = (options) => {
        const obj = [];
        const beanList = requisitionDetails.requestedItemsBeanList;
        if (options.length <= 0) {
            return;
        }
        for (let i = 0; i < beanList.length; i++) {
            for (let j = 0; j < options.length; j++) {
                if (beanList[i].itemId === options[j].itemId) {
                    let unitConversion = options[j].unitConversion?.split(":")[1];
                    let unitConversionTitle = options[j].unitConversionTitle?.split(":");
                    let updatedStock;
                    let updatedInHandQty;
                    let openIssuedQuantity;
                    let openRequestedQuantity;
                    if (beanList[i].unitTitle === unitConversionTitle[0].trim()) {
                        updatedStock = ((options[j].currentStockOpenQuantity / unitConversion) + options[j].currentStockBoxQuantity).toFixed(2);
                        updatedInHandQty = ((beanList[i].inHandQuantity / unitConversion)).toFixed(2);
                    } else {
                        updatedStock = ((options[j].currentStockBoxQuantity * unitConversion) + options[j].currentStockOpenQuantity).toFixed(2);
                        updatedInHandQty = ((beanList[i].inHandQuantity)).toFixed(2)
                    }
                    const issuedQty = Math.ceil(Math.max(0, beanList[i].quantity - updatedInHandQty));

                    if (beanList[i].unitTitle === unitConversionTitle[0].trim()) {
                        openIssuedQuantity = getFormattedNumber(issuedQty * unitConversion);
                        openRequestedQuantity = getFormattedNumber(beanList[i].quantity * unitConversion);
                    } else {
                        openIssuedQuantity = 0;
                        openRequestedQuantity = 0;
                    }

                    let itemObj = {
                        item: {
                            label: beanList[i].itemTitle,
                            value: beanList[i].itemId,
                        },
                        itemId: beanList[i].itemId,
                        stock: getFormattedNumber(updatedStock),
                        requestedQuantity: beanList[i].quantity,
                        openRequestedQuantity: openRequestedQuantity,
                        issuedQuantity: parseInt(issuedQty),
                        inHandQuantity: updatedInHandQty,
                        inHandQuantityUnitTitleUuid: beanList[i].inHandQuantityUnitTitleUuid,
                        inHandQuantityUnitTitle: beanList[i].inHandQuantityUnitTitle,
                        openIssuedQuantity: openIssuedQuantity,
                        unitConversion: options[j].unitConversion,
                        unitConversionTitle: options[j].unitConversionTitle,
                        currentStockBoxQuantity: options[j].currentStockBoxQuantity,
                        currentStockOpenQuantity: options[j].currentStockOpenQuantity,
                        updatedInHandQty: beanList[i].inHandQuantity,
                        units: options[j].units,
                        selectedUnit: {
                            value: beanList[i].unitId,
                            label: beanList[i].unitTitle,
                            stock: options[j].selectedUnit.stock,
                        },
                        beanBatchList: [],
                        beanBillBatch: [],
                    };
                    obj.push(itemObj);
                    break;
                }
            }
        }
        if (obj.length > 0) {
            setRows(obj);
            obj.forEach((r, idx) => loadBatchesForRow(idx, r.itemId));
        }
    };

    // Batches are fetched per item when it is picked, so the item list itself stays fast.
    const loadBatchesForRow = (index, itemUuid) => {
        const warehouseUuid = issInfo.ware?.value || requisitionDetails?.warehouseId;
        if (!warehouseUuid || !itemUuid) return;
        setRows((prev) => prev.map((r, i) => (i === index ? { ...r, batchLoading: true, beanBatchList: [] } : r)));
        getStoreTransferAvailableBatches(warehouseUuid, itemUuid).then((res) => {
            let list = [];
            if (res.errorCode === 0) {
                list = (res.responsePacket || []).map((b) => ({
                    recordId: b.sourceRecordId,
                    itemId: b.itemId,
                    batchNumber: b.batchNumber,
                    batchQuantity: b.availableQuantity,
                    batchManufacturingDate: b.batchManufacturingDate,
                    batchExpiredDate: b.batchExpiredDate,
                    storeTitle: b.storeTitle,
                    rackTitle: b.rackTitle,
                    cellTitle: b.cellTitle,
                    palletTitle: b.palletTitle,
                    referenceNo: b.referenceNo,
                }));
            } else {
                toast.error(res.message);
            }
            setRows((prev) => prev.map((r, i) => (i === index && r.itemId === itemUuid ? { ...r, beanBatchList: list, batchLoading: false } : r)));
        }).catch(() => {
            toast.error("Could not load batches");
            setRows((prev) => prev.map((r, i) => (i === index ? { ...r, batchLoading: false } : r)));
        });
    };

    useEffect(() => {
        if (rows && rows.length > 0) {
            var setSend = false;
            var filterOptions = [];
            itemOptions2 &&
                itemOptions2?.map((a) => {
                    rows &&
                        rows?.map((b) => {
                            if (a.itemId === b?.item?.value) {
                                setSend = true;
                            }
                        });
                    if (!setSend) {
                        filterOptions.push(a);
                    }
                    setSend = false;
                });
            setItemOptions([...filterOptions]);
        }
    }, [rows]);

    const handleAddRow = () => {
        setRows([...rows, tempRow]);
    };

    const handleIssuedQuantity = (e, i) => {
        const obj = [...rows];
        let issuedQuantity = e.target.value;
        if (parseFloat(issuedQuantity) <= parseFloat(obj[i].stock)) {
            let unitConversion = obj[i].unitConversion?.split(":")[1];
            let unitConversionTitle = obj[i].unitConversionTitle?.split(":");
            let openIssuedQuantity;
            if (obj[i].selectedUnit.label === unitConversionTitle[0].trim()) {
                openIssuedQuantity = getFormattedNumber(issuedQuantity * unitConversion);
            } else {
                openIssuedQuantity = 0;
            }
            obj[i].issuedQuantity = issuedQuantity;
            obj[i].openIssuedQuantity = openIssuedQuantity;
            setRows(obj);
        }
    }

    const handleRequestedQuantity = (e, i) => {
        const obj = [...rows];
        const qt = Number(e.target.value);
        obj[i].requestedQuantity = qt;
        const issuedQty = Math.ceil(Math.min(obj[i].stock, Math.max(0, qt - obj[i].inHandQuantity)));
        let unitConversion = obj[i].unitConversion?.split(":")[1];
        let unitConversionTitle = obj[i].unitConversionTitle?.split(":");
        let openIssuedQuantity;
        let openRequestedQuantity;
        if (obj[i].selectedUnit.label === unitConversionTitle[0].trim()) {
            openIssuedQuantity = getFormattedNumber(issuedQty * unitConversion);
            openRequestedQuantity = getFormattedNumber(qt * unitConversion);
        } else {
            openIssuedQuantity = 0;
            openRequestedQuantity = 0;
        }
        obj[i].issuedQuantity = issuedQty;
        obj[i].openIssuedQuantity = openIssuedQuantity;
        obj[i].openRequestedQuantity = openRequestedQuantity;
        setRows(obj);
    }

    const handleItem = (e, i) => {
        const obj = [...rows];
        obj[i].item = {
            label: e.itemTitle,
            value: e.itemTitle,
        };
        obj[i].itemId = e.itemId;
        obj[i].qty = 0;
        obj[i].units = e.units;
        obj[i].selectedUnit = e.selectedUnit;
        obj[i].unitConversion = e.unitConversion;
        obj[i].unitConversionTitle = e.unitConversionTitle;
        obj[i].currentStockBoxQuantity = e.units[1].stock;
        obj[i].currentStockOpenQuantity = e.units[0].stock;
        obj[i].inHandQuantity = e.inHandQuantity;
        obj[i].inHandQuantityUnitTitle = e.inHandQuantityUnitTitle;
        obj[i].requestedQuantity = 0;
        obj[i].issuedQuantity = 0;
        obj[i].updatedInHandQty = e.inHandQuantity;

        let unitConversion = e.unitConversion.split(":")[1];
        let updatedStock = (e.units[1].stock * unitConversion) + e.units[0].stock;
        obj[i].stock = updatedStock;
        obj[i].beanBatchList = [];
        obj[i].beanBillBatch = [];
        const filteredOptions = itemOptions2.filter((item) => item.itemId !== e.itemId);
        setItemOptions2(filteredOptions);
        setRows(obj);
        loadBatchesForRow(i, e.itemId);
    };

    const handleCancel = () => {
        navigate('/issueitems', { state: { tab: "requisition" } });
    }
    const handleSave = () => {
        if (issInfo.ware === "") {
            toast("Select Warehouse");
            return;
        }

        if (issInfo.user === "") {
            toast("Select user");
            return;
        }
        if (issInfo.dept === "") {
            toast("Select Department");
            return;
        }

        // Every issued item must say which batch rows it comes from, adding up to the issued quantity.
        const batchError = validateBatches();
        if (batchError) {
            toast.error(batchError);
            return;
        }

        setLoading(true);
        let itemBeanList = [];
        rows?.map((item) => {
            const openQtyUnit = item?.unitConversionTitle?.split(":")[1].trim();
            const openQtyUnitUuid = item?.units?.find((value) => openQtyUnit === value.label);

            if (item.qty > 0) {
                const itemObj = {
                    itemId: item.itemId,
                    itemTitle: item.item.label,
                    inHandQuantity: item.inHandQuantity,
                    HandQuantityUnitTitleUuid: item.HandQuantityUnitTitleUuid,
                    currentRequestQuantity: item.qty,
                    currentRequestQuantityUnitTitleUuid: item.selectedUnit.value,
                    currentIssuedQuantity: item.issuanceQuantity,
                    currentIssuedQuantityUnitTitleUuid: item.issuanceUnitId,
                    inHandQuantityUnitTitleUuid: openQtyUnitUuid.value,
                    itemId: item.itemId,
                    issuedQuantity: item.issuanceQuantity,
                    issuedQuantityUnitId: item.issuedSelectedUnit.value,
                    issuedQuantityUnitTitle: item.issuedSelectedUnit.label,
                    openIssuedQuantity: item.openIssuedQuantity,
                    warehouseId: item.item.warehouseId,
                    warehouseTitle: item.item.warehouseTitle,
                    currentStockOpenQuantity: item.currentStockOpenQuantity,
                    inStockQty: item.stock,
                    beanBillBatch: (item?.beanBillBatch || []).map((b) => ({ recordId: b.recordId, batchNumber: b.batchNumber, qtyConsumed: Number(b.qtyConsumed) })),

                };
                if (reqId) {
                    itemObj.requestedQuantity = item.selectedUnit.stock;
                    itemObj.requestedUnitId = item.requestedUnitId;
                    itemObj.requestedUnitTitle = item.requestedUnitTitle;
                } else {
                    itemObj.requestedQuantity = item.qty;
                    itemObj.requestedUnitId = item.selectedUnit.value;
                    itemObj.requestedUnitTitle = item.selectedUnit.label;
                }

                itemBeanList.push(itemObj);
            }

            if (item.issuedQuantity >= 0) {
                const issuedQuantityObj = {
                    inHandQuantity: item.updatedInHandQty,
                    inHandUnitTitle: item.inHandQuantityUnitTitle,
                    requestedUnitTitle: item.selectedUnit.label,
                    requestedQuantity: item.requestedQuantity,
                    requestedUnitId: item.selectedUnit.value,
                    currentRequestQuantity: item.requestedQuantity,
                    currentRequestQuantityUnitTitleUuid: item.selectedUnit.value,
                    inHandQuantityUnitTitleUuid: openQtyUnitUuid.value,
                    currentIssuedQuantity: item.issuedQuantity,
                    issuedQuantity: item.issuedQuantity,
                    issuedQuantityUnitId: item.selectedUnit.value,
                    issuedQuantityUnitTitle: item.selectedUnit.label,
                    openIssuedQuantity: item.openIssuedQuantity,
                    openRequestedQuantity: item.openRequestedQuantity,
                    currentIssuedQuantityUnitTitleUuid: item.selectedUnit.value,
                    itemId: item.itemId,
                    issuedDepartmentId: issInfo.dept.value,
                    currentStockOpenQuantity: item.currentStockOpenQuantity,
                    currentStockBoxQuantity: item.currentStockBoxQuantity,
                    inStockQty: item.stock,
                    beanBillBatch: (item?.beanBillBatch || []).map((b) => ({ recordId: b.recordId, batchNumber: b.batchNumber, qtyConsumed: Number(b.qtyConsumed) })),
                }
                itemBeanList.push(issuedQuantityObj);
            } else {
                toast("Select Issued Quantity");
            }

        });
        if (itemBeanList?.length === 0) {
            setLoading(false);
            return;
        }
        const data = {

            issuanceDate: issInfo.date,
            warehouseId: issInfo.ware.value,
            warehouseTitle: issInfo.ware.label,
            issuedByUserId: issInfo.user.value,
            issuedByUserTitle: issInfo.user.label,
            requestingDepartmentId: issInfo.dept.value,
            issuedDepartmentTitle: issInfo.dept.label,
            issuedItemsList: itemBeanList,
            note: issInfo.note,
            noteByIssue: issInfo.noteByIssue,
            issuedDepartmentId: issInfo.dept.value,
        };
        if (reqId && onPage === "issuanceFromRequisition") {
            let partiallyFulfilled = false;
            for (let i = 0; i < rows.length; i++) {
                if (rows[i].qty < rows[i].selectedUnit.stock) {
                    partiallyFulfilled = true;
                    break;
                }
            }
            data.issuedByUserId = loginData1.recordId;
            data.issuedByUserTitle = loginData1.fullName;
            data.requisitionCode = requisitionDetails.requisitionCode;
            data.issuanceDate = curr.toISOString();
            data.requisitionId = requisitionDetails.recordId;
            data.issuedToUserId = requisitionDetails.requestingUserId;
            data.issuedToUserTitle = requisitionDetails.requestingUserTitle;
            data.partiallyFulfilled = partiallyFulfilled;
            data.fulfilled = !partiallyFulfilled;
            data.warehouseId = requisitionDetails.warehouseId;
            data.warehouseTitle = requisitionDetails.warehouseTitle;
        }

        addIssuance(data)
            .then((res) => {
                if (res.errorCode === 0) {
                    toast(res.message);
                    navigate("/issueitems");
                } else {
                    toast(res.message);
                }
                setLoading(false);
            })
            .catch(() => {
                toast.error("server error");
                setLoading(false);
                return;
            });
    };

    const getRequisitionList = () => {
        var data = {
            page: 0,
            search: "",
            size: -1,
            uuid: warehouseIdIss,
        };
        setLoading(true)
        getPendingRequisition(data).then((res) => {
            if (res.errorCode === 0) {
                let temp = sortLatestFirst(res.responsePacket.data, "requestDate");
                setRequisitionList(temp);
                setFilteredRequisitionList(temp);
            } else {
                toast.error(res.message);
            }
            setLoading(false)
        }).catch(error => setLoading(false));
    };

    const handleAcceptRejectRequisition = (id, type) => {
        acceptRejectRequisition(id, type)
            .then((res) => {
                if (res.errorCode === 0) {
                    getRequisitionList();
                    navigate('/issueitems', { state: { tab: "requisition" } });
                    toast(res.message);
                } else {
                    toast(res.message);
                }
            })
            .catch(() => {
                toast.error("server error");
                return;
            });
    };

    const handleSelectUnit = (e, i) => {
        const obj = [...rows];
        obj[i].selectedUnit = e;
        let unitConversion = obj[i].unitConversion?.split(":")[1];
        let unitConversionTitle = obj[i].unitConversionTitle?.split(":");
        let updatedStock;
        let updatedInHandQty;
        let openIssuedQuantity;
        let openRequestedQuantity;
        if (e.label === unitConversionTitle[0].trim()) {
            updatedStock = ((obj[i].currentStockOpenQuantity / unitConversion) + obj[i].currentStockBoxQuantity).toFixed(2);
            updatedInHandQty = ((obj[i].updatedInHandQty / unitConversion)).toFixed(2);
            openIssuedQuantity = getFormattedNumber(obj[i].issuedQuantity * unitConversion);
            openRequestedQuantity = getFormattedNumber(obj[i].requestedQuantity * unitConversion);
        } else {
            updatedStock = ((obj[i].currentStockBoxQuantity * unitConversion) + obj[i].currentStockOpenQuantity).toFixed(2);
            updatedInHandQty = ((obj[i].updatedInHandQty)).toFixed(2);
            openIssuedQuantity = 0;
            openRequestedQuantity = 0;
        }
        obj[i].openIssuedQuantity = openIssuedQuantity;
        obj[i].openRequestedQuantity = openRequestedQuantity;
        obj[i].inHandQuantity = updatedInHandQty;
        obj[i].stock = getFormattedNumber(updatedStock);
        obj[i].issuedQuantity = Math.min(obj[i].stock, Math.ceil(Math.max(0, obj[i].requestedQuantity - updatedInHandQty)));
        setRows(obj);
    };

    const checkForDisable = () => {
        if (issInfo.ware.value === "" || issInfo.dept.value === "") {
            return true;
        }
        return false;
    };
    const batchLoc = (b) => [b?.storeTitle, b?.rackTitle, b?.cellTitle, b?.palletTitle].map((v) => v || "N/A").join(" / ");

    // Returns an error message when batch rows are missing or do not add up, otherwise null.
    const validateBatches = () => {
        for (let i = 0; i < rows.length; i++) {
            const r = rows[i];
            if (!r.item || r.item === "" || !r.itemId) continue;
            const issued = Number(r.issuedQuantity || 0);
            if (issued <= 0) continue;
            const name = r.item.label || `row ${i + 1}`;
            const batches = r.beanBillBatch || [];
            if (batches.length === 0) {
                if (r.batchLoading) return `Batches are still loading for ${name}, please wait`;
                // Legacy stock: the item has no batch rows in this warehouse at all, so there is nothing to
                // select. Backend applies the same rule and issues on warehouse stock only.
                if ((r.beanBatchList || []).length === 0) continue;
                return `Select batch for ${name}`;
            }
            let total = 0;
            for (let j = 0; j < batches.length; j++) {
                const b = batches[j];
                if (!b.recordId) return `Select batch for ${name} (batch row ${j + 1})`;
                const qty = Number(b.qtyConsumed);
                if (isNaN(qty) || qty <= 0) return `Batch quantity must be greater than 0 for ${name} (${b.batchNumber})`;
                if (qty > Number(b.batchQuantity) + 0.0001) return `Only ${b.batchQuantity} available in batch ${b.batchNumber} for ${name}`;
                total += qty;
            }
            if (Math.abs(total - issued) > 0.0001) return `Batch quantity total (${total}) must equal issued quantity (${issued}) for ${name}`;
        }
        return null;
    };

    const handleSubRow = (itemIndex) => {
        const data = rows.map((e, i) => {
            if (i === itemIndex) {
                return {
                    ...e, beanBillBatch: [...e?.beanBillBatch, {
                        batchQuantity: 0,
                        batchNumber: "",
                        Rate: "",
                        batchManufacturingDate: "",
                        batchExpiredDate: "",
                        qtyConsumed: 0
                    }]
                }
            }
            else {
                return e;
            }
        })
        setRows(data)
    }
    const removeSubRows = (i, j) => {
        const data = rows.map((item, ind) => {
            if (ind !== i) {
                return item;
            }
            else {
                return { ...item, beanBillBatch: item.beanBillBatch.filter((item2, index2) => index2 !== j) }
            }
        })
        setRows(data)
    }

    const handleSubRowchanges = (i, j, e, name, quantity, batchNumber) => {
        if (name === "qtyConsumed") {
            if (Number(e) > Number(quantity)) {
                toast.error("Quantity selected is greater than available");
                return;
            }
        }
        const data = rows.map((row, ind) => {
            if (ind === i) {
                return {
                    ...row,
                    beanBillBatch: row.beanBillBatch.map((bean, index) => {
                        if (index === j && name === "batchNumber") {
                            return { ...e, qtyConsumed: "" }
                        }
                        if (index === j && name === "qtyConsumed") {
                            return { ...bean, [name]: e }
                        }
                        return bean;
                    })
                };
            }
            return row;
        });
        setRows(data);
    };

    return (
        <>
            <div className="col-12" style={{ paddingLeft: "20px" }}>
                <h1 className="fill list-header d-flex  align-items-center bg-white p-3 border-bottom">
                    <ReceiptIcon />
                    {reqId ? "Edit " : "New "} Item Issuance&nbsp;
                    <span className="text-primary font-weight-bold"> {issInfo?.reqCode ? `  - ${issInfo.reqCode}` : ""}</span>
                </h1>
                <br />
                <table className="customTable">
                    <tbody>
                        <tr>
                            <td>Warehouse:</td>
                            <td>
                                <Select isDisabled={reqId ? true : false} value={issInfo.ware} options={wareOptions} onChange={(e) => handleWare(e)} />
                            </td>
                        </tr>
                        <tr>
                            <td>User:</td>
                            <td>
                                <input autoComplete="off" className="form-control" value={issInfo.user.label} disabled />
                            </td>
                        </tr>
                        <tr>
                            <td>Department:</td>
                            <td>
                                <Select isDisabled={reqId ? true : false} value={issInfo.dept} options={deptOptions} onChange={(e) => handleDepartmentSelect(e)} />
                            </td>
                        </tr>
                        <tr>
                            <td>Date:</td>
                            <td>
                                <input
                                    autoComplete="off"
                                    disabled={reqId ? true : false}
                                    type="date"
                                    className="form-control"
                                    value={issInfo.date}
                                    onChange={(e) => setIssInfo({ ...issInfo, date: e.target.value })}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Note By Issuer:</td>
                            <td>
                                <input autoComplete="off" className="form-control" value={issInfo.noteByIssue} onChange={(e) => setIssInfo({ ...issInfo, noteByIssue: e.target.value })} />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <table className="customTable col-12">
                    <tbody>
                        <tr>
                            <>
                                <td></td>
                                <td>Sno.</td>
                                <td>Item</td>
                                <td>Stock</td>
                                <td>Requested Quantity</td>
                                <td>Inhand Quantity</td>
                                <td>Issued Quantity</td>
                                <td> Issued Unit</td>
                            </>
                            <td></td>
                        </tr>
                        {rows &&
                            rows?.map((data, i) => {
                                return (
                                    <Fragment key={i}>
                                        <tr key={i} >
                                            <td>
                                                <div className={itemLoading ? "spinner-loader" : ""}></div>
                                            </td>
                                            <td>{i + 1}</td>
                                            <td className="selectMenuItemList">
                                                <Select isDisabled={checkForDisable() || itemLoading} options={itemOptions} value={data.item} onChange={(e) => handleItem(e, i)} />
                                            </td>

                                            <td>
                                                <span>
                                                    {getFormattedNumber(data?.stock)}
                                                </span>
                                            </td>
                                            <td>
                                                <input autoComplete="off" disabled={checkForDisable() || !!reqId} id="requestedQuantity" type="number" min={0} value={data?.requestedQuantity} onChange={(e) => handleRequestedQuantity(e, i)} />
                                            </td>
                                            <td>
                                                <span>
                                                    {getFormattedNumber(data?.inHandQuantity)}
                                                </span>
                                            </td>

                                            <td>
                                                <input autoComplete="off" disabled={checkForDisable()} id="issuedQuantity" type="number" min={0} value={data?.issuedQuantity} onChange={(e) => handleIssuedQuantity(e, i)} />
                                            </td>

                                            <td>
                                                <Select isDisabled={checkForDisable()} value={data.selectedUnit} options={data.units} onChange={(e) => handleSelectUnit(e, i)} />
                                            </td>
                                        </tr>
                                        {data?.itemId && (<tr style={{ width: "100%" }}>
                                            <td style={{ padding: 0 }} colSpan={16}>
                                                <table style={{ width: "100%", paddingRight: "5px" }} className=" border text-center sub-table">
                                                    <thead>
                                                        <tr className="border">
                                                            <td> Batch <span className="text-danger">*</span></td>
                                                            <td> Available </td>
                                                            <td> Store / Rack / Cell / Pallet </td>
                                                            <td> Issue Qty <span className="text-danger">*</span></td>
                                                            <td> Mfg </td>
                                                            <td> Expiry </td>
                                                            <td style={{ width: "30px" }}>
                                                                <button
                                                                    id="ember1426"
                                                                    className="btn btn-default addbtn"
                                                                    onClick={() => handleSubRow(i)}
                                                                >
                                                                    <AddIcon
                                                                        style={{ color: "blue", }}
                                                                    />{" "}
                                                                    Add
                                                                    More

                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </thead>
                                                    {data?.beanBillBatch?.map((billBatch, j) => {
                                                        let allBatchOptions = data?.beanBatchList?.filter((e) => !data?.beanBillBatch.find((f) => f.recordId === e?.recordId))
                                                        return <tbody>
                                                            <tr>
                                                                <td  >
                                                                    <Select
                                                                        isDisabled={itemLoading || data?.batchLoading}
                                                                        isLoading={data?.batchLoading}
                                                                        styles={{
                                                                            control: (base) => ({
                                                                                ...base,
                                                                                minWidth: '180px',
                                                                                fontSize: "13px"
                                                                            }),
                                                                            menu: (base) => ({
                                                                                ...base,
                                                                                minWidth: '180px',
                                                                                fontSize: "13px"
                                                                            }),
                                                                        }}
                                                                        name="batchNumber"
                                                                        onChange={(e) => handleSubRowchanges(i, j, e, "batchNumber")}
                                                                        value={billBatch?.recordId ? {
                                                                            value: billBatch.recordId,
                                                                            label: billBatch.batchNumber
                                                                        } : null}
                                                                        placeholder="Select Batch"
                                                                        options={[...(allBatchOptions && allBatchOptions?.length > 0
                                                                            ? allBatchOptions.map(e => ({
                                                                                ...e,
                                                                                value: e.recordId,
                                                                                label: `${e.batchNumber} | ${e.batchQuantity} | ${batchLoc(e)}`
                                                                            }))
                                                                            : []
                                                                        )
                                                                        ]}
                                                                    />


                                                                </td>
                                                                <td>{billBatch?.recordId ? billBatch.batchQuantity : ""}</td>
                                                                <td style={{ fontSize: "12px" }}>{billBatch?.recordId ? batchLoc(billBatch) : ""}</td>
                                                                <td>
                                                                    <input
                                                                        value={billBatch?.qtyConsumed}
                                                                        type="text"
                                                                        name="qtyConsumed"
                                                                        onChange={(e) => handleSubRowchanges(i, j, e.target.value, "qtyConsumed", billBatch?.batchQuantity, billBatch.batchNumber)}
                                                                        isDisabled={itemLoading}
                                                                        disabled={!billBatch?.batchNumber || itemLoading}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        value={billBatch?.batchManufacturingDate}
                                                                        type="date"
                                                                        name="batchManufacturingDate"
                                                                        onChange={(e) => handleSubRowchanges(i, j, e.target.value, "batchManufacturingDate")}
                                                                        disabled={true}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        value={billBatch?.batchExpiredDate}
                                                                        type="date"
                                                                        name="batchExpiredDate"
                                                                        onChange={(e) => handleSubRowchanges(i, j, e.target.value, "batchExpiredDate")}
                                                                        disabled={true}
                                                                    />
                                                                </td>
                                                                <td style={{ width: "30px" }}>
                                                                    <button
                                                                        className="btn btn-default addbtn"
                                                                        onClick={() => removeSubRows(i, j)}
                                                                    >
                                                                        X
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    }
                                                    )}
                                                </table>
                                            </td>
                                        </tr>)}
                                    </Fragment>
                                );
                            })}
                    </tbody>
                </table>

                {!checkForDisable() && (
                    <>
                        {!reqId && (
                            <div>
                                <button id="ember1426" className="btn btn-default addbtn mt-3" onClick={handleAddRow}>
                                    <AddIcon style={{ color: "blue" }} /> New Row
                                </button>
                            </div>
                        )}
                        {rows[0].item !== "" && (
                            <>
                                <br />
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        {loading ? (
                                            <Button variant="contained">
                                                <Spinner />
                                            </Button>
                                        ) : (
                                            <Button variant="contained" onClick={handleSave}>
                                                Save
                                            </Button>

                                        )}
                                        <Button variant="contained" className="ml-3" onClick={handleCancel}>
                                            Cancel
                                        </Button>
                                    </div>

                                    {reqId && (
                                        <button className="mr-4 btn btn-danger" onClick={() => handleAcceptRejectRequisition(reqId, "reject")}>
                                            Reject
                                        </button>
                                    )}
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>
            <Toaster />
        </>
    );
};

export default IssuanceNew;